export interface Prefecture {
  code: string   // JIS X 0401 (01-47)
  name: string   // 日本語正式名称
  romaji: string // 英字表記
}

export const PREFECTURES: readonly Prefecture[] = [
  { code: '01', name: '北海道', romaji: 'Hokkaido' },
  { code: '02', name: '青森県', romaji: 'Aomori' },
  { code: '03', name: '岩手県', romaji: 'Iwate' },
  { code: '04', name: '宮城県', romaji: 'Miyagi' },
  { code: '05', name: '秋田県', romaji: 'Akita' },
  { code: '06', name: '山形県', romaji: 'Yamagata' },
  { code: '07', name: '福島県', romaji: 'Fukushima' },
  { code: '08', name: '茨城県', romaji: 'Ibaraki' },
  { code: '09', name: '栃木県', romaji: 'Tochigi' },
  { code: '10', name: '群馬県', romaji: 'Gunma' },
  { code: '11', name: '埼玉県', romaji: 'Saitama' },
  { code: '12', name: '千葉県', romaji: 'Chiba' },
  { code: '13', name: '東京都', romaji: 'Tokyo' },
  { code: '14', name: '神奈川県', romaji: 'Kanagawa' },
  { code: '15', name: '新潟県', romaji: 'Niigata' },
  { code: '16', name: '富山県', romaji: 'Toyama' },
  { code: '17', name: '石川県', romaji: 'Ishikawa' },
  { code: '18', name: '福井県', romaji: 'Fukui' },
  { code: '19', name: '山梨県', romaji: 'Yamanashi' },
  { code: '20', name: '長野県', romaji: 'Nagano' },
  { code: '21', name: '岐阜県', romaji: 'Gifu' },
  { code: '22', name: '静岡県', romaji: 'Shizuoka' },
  { code: '23', name: '愛知県', romaji: 'Aichi' },
  { code: '24', name: '三重県', romaji: 'Mie' },
  { code: '25', name: '滋賀県', romaji: 'Shiga' },
  { code: '26', name: '京都府', romaji: 'Kyoto' },
  { code: '27', name: '大阪府', romaji: 'Osaka' },
  { code: '28', name: '兵庫県', romaji: 'Hyogo' },
  { code: '29', name: '奈良県', romaji: 'Nara' },
  { code: '30', name: '和歌山県', romaji: 'Wakayama' },
  { code: '31', name: '鳥取県', romaji: 'Tottori' },
  { code: '32', name: '島根県', romaji: 'Shimane' },
  { code: '33', name: '岡山県', romaji: 'Okayama' },
  { code: '34', name: '広島県', romaji: 'Hiroshima' },
  { code: '35', name: '山口県', romaji: 'Yamaguchi' },
  { code: '36', name: '徳島県', romaji: 'Tokushima' },
  { code: '37', name: '香川県', romaji: 'Kagawa' },
  { code: '38', name: '愛媛県', romaji: 'Ehime' },
  { code: '39', name: '高知県', romaji: 'Kochi' },
  { code: '40', name: '福岡県', romaji: 'Fukuoka' },
  { code: '41', name: '佐賀県', romaji: 'Saga' },
  { code: '42', name: '長崎県', romaji: 'Nagasaki' },
  { code: '43', name: '熊本県', romaji: 'Kumamoto' },
  { code: '44', name: '大分県', romaji: 'Oita' },
  { code: '45', name: '宮崎県', romaji: 'Miyazaki' },
  { code: '46', name: '鹿児島県', romaji: 'Kagoshima' },
  { code: '47', name: '沖縄県', romaji: 'Okinawa' },
]

export const AREA_TAGS: readonly string[] = [
  '駅前',
  '海沿い',
  '商店街',
  '下町',
  '繁華街',
]
